import React from 'react'

const BannerSection = () => {
    return (
        <>
            <section className="bannerSec innerBanner">
                <div className="box-position" style={{background: 'url("images/innerBanner.jpg")'}}>

                </div>
                <div className="bannerTxt">
                    <h1>Packages</h1>
                </div>
            </section>
        </>
    )
}

export default BannerSection